var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureFeature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 19.5,
    stroke: "#19C48F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_1461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 20.5C34.6576 20.5 36.2473 21.1585 37.4194 22.3306C38.5915 23.5027 39.25 25.0924 39.25 26.75V30.5C40.2446 30.5 41.1984 30.8951 41.9017 31.5983C42.6049 32.3016 43 33.2554 43 34.25V41.75C43 42.7446 42.6049 43.6984 41.9017 44.4017C41.1984 45.1049 40.2446 45.5 39.25 45.5H26.75C25.7554 45.5 24.8016 45.1049 24.0983 44.4017C23.3951 43.6984 23 42.7446 23 41.75V34.25C23 33.2554 23.3951 32.3016 24.0983 31.5983C24.8016 30.8951 25.7554 30.5 26.75 30.5V26.75C26.75 25.0924 27.4085 23.5027 28.5806 22.3306C29.7527 21.1585 31.3424 20.5 33 20.5ZM33 35.5C32.3693 35.4998 31.7618 35.738 31.2993 36.1669C30.8368 36.5957 30.5536 37.1836 30.5063 37.8125L30.5 38C30.5 38.4945 30.6466 38.9778 30.9213 39.3889C31.196 39.8 31.5865 40.1205 32.0433 40.3097C32.5001 40.4989 33.0028 40.5484 33.4877 40.452C33.9727 40.3555 34.4181 40.1174 34.7678 39.7678C35.1174 39.4181 35.3555 38.9727 35.452 38.4877C35.5484 38.0028 35.4989 37.5001 35.3097 37.0433C35.1205 36.5865 34.8 36.196 34.3889 35.9213C33.9778 35.6466 33.4945 35.5 33 35.5ZM33 23C32.0054 23 31.0516 23.3951 30.3483 24.0983C29.6451 24.8016 29.25 25.7554 29.25 26.75V30.5H36.75V26.75C36.75 25.7554 36.3549 24.8016 35.6517 24.0983C34.9484 23.3951 33.9946 23 33 23Z",
    fill: "#19C48F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_1461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureFeature);
export default __webpack_public_path__ + "static/media/secure_feature.dadd373551da625c07231e01e641298f.svg";
export { ForwardRef as ReactComponent };